import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { toZonedTime, fromZonedTime, formatInTimeZone } from 'date-fns-tz';
import { format as dateFnsFormat } from 'date-fns';
import { es } from 'date-fns/locale';

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Zona horaria de Chile
export const CHILE_TZ = 'America/Santiago';

// Convierte cualquier fecha a hora de Chile
export function toChileTime(date) {
  if (!date) return null;
  return toZonedTime(new Date(date), CHILE_TZ);
}

// Obtiene "ahora" en hora de Chile
export function nowChile() {
  return toZonedTime(new Date(), CHILE_TZ);
}

// Formatea fecha en hora de Chile: dd/MM/yyyy HH:mm
export function formatDate(date) {
  if (!date) return '-';
  const chileDate = toChileTime(date);
  return dateFnsFormat(chileDate, "dd/MM/yyyy HH:mm", { locale: es });
}

// Convierte una fecha UTC (ISO) al formato del input datetime-local en hora Chile (YYYY-MM-DDTHH:mm)
export function utcToChileInput(date) {
  if (!date) return '';
  return formatInTimeZone(new Date(date), CHILE_TZ, "yyyy-MM-dd'T'HH:mm");
}

// Convierte el valor de un input datetime-local (interpretado como hora Chile) a ISO UTC para enviar al backend
export function chileInputToUTC(localValue) {
  if (!localValue) return null;
  // localValue es "YYYY-MM-DDTHH:mm" en hora de Chile
  return fromZonedTime(localValue, CHILE_TZ).toISOString();
}

// Formatea solo fecha en hora de Chile: dd MMM yyyy
export function formatDateShort(date) {
  if (!date) return '-';
  const chileDate = toChileTime(date);
  return dateFnsFormat(chileDate, 'dd MMM yyyy', { locale: es });
}

// Formatea fecha corta: dd MMM
export function formatDateCompact(date) {
  if (!date) return '-';
  const chileDate = toChileTime(date);
  return dateFnsFormat(chileDate, 'dd MMM', { locale: es });
}

// Format relative time (usando hora Chile)
export function formatRelativeTime(date) {
  if (!date) return '-';
  const now = toChileTime(new Date());
  const then = toChileTime(date);
  const diff = now - then;
  
  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);
  
  if (minutes < 1) return 'Ahora';
  if (minutes < 60) return `Hace ${minutes}m`;
  if (hours < 24) return `Hace ${hours}h`;
  if (days < 7) return `Hace ${days}d`;
  
  return formatDate(date);
}

// Status colors and labels (Light theme optimized)
export const statusConfig = {
  nuevo: { label: 'Nuevo', color: 'bg-blue-100 text-blue-700 border-blue-200' },
  asignado: { label: 'Asignado', color: 'bg-purple-100 text-purple-700 border-purple-200' },
  en_progreso: { label: 'En Progreso', color: 'bg-amber-100 text-amber-700 border-amber-200' },
  en_espera: { label: 'En Espera', color: 'bg-gray-100 text-gray-700 border-gray-200' },
  resuelto: { label: 'Resuelto', color: 'bg-emerald-100 text-emerald-700 border-emerald-200' },
  validacion: { label: 'Validación', color: 'bg-cyan-100 text-cyan-700 border-cyan-200' },
  cerrado: { label: 'Cerrado', color: 'bg-slate-100 text-slate-700 border-slate-200' },
};

// Priority colors and labels (Light theme optimized)
export const priorityConfig = {
  baja: { label: 'Baja', color: 'bg-slate-100 text-slate-700 border-slate-200' },
  media: { label: 'Media', color: 'bg-blue-100 text-blue-700 border-blue-200' },
  alta: { label: 'Alta', color: 'bg-amber-100 text-amber-700 border-amber-200' },
  critica: { label: 'Crítica', color: 'bg-rose-100 text-rose-700 border-rose-200' },
};

// Role labels (Light theme optimized)
export const roleConfig = {
  solicitante: { label: 'Solicitante', color: 'bg-blue-100 text-blue-700' },
  solucionador: { label: 'Solucionador', color: 'bg-[#7FD02E]/20 text-[#5BA51E]' },
  jefatura: { label: 'Jefatura', color: 'bg-purple-100 text-purple-700' },
  admin: { label: 'Administrador', color: 'bg-rose-100 text-rose-700' },
};
